export const coverOptions = [
  { value: 'is-fullscreen', label: 'Full Screen' },
  { value: 'is-fixedheight', label: 'Fixed' }
]
